import { createFileRoute } from '@tanstack/react-router';

import { CreateRecitalPage } from '~features/recital-manager';

export const Route = createFileRoute('/_auth/_layout/recitals/new')({
  component: CreateRecitalPage,
});
